export default __webpack_public_path__ + "static/customer-ffa5cc5ccb5d8d82efcec2d8562e3801.jpg";